module.exports = __webpack_public_path__ + "img/employeehub-logo.e7877d16.svg";